import { render, staticRenderFns } from "./IntegrationsWise.vue?vue&type=template&id=25824b80&scoped=true&"
import script from "./IntegrationsWise.vue?vue&type=script&lang=js&"
export * from "./IntegrationsWise.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsWise.vue?vue&type=style&index=0&id=25824b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25824b80",
  null
  
)

export default component.exports